export const styles = {
  branches: {
    width: '100%',
    minHeight: '560px',
    '& > * > *': {
      borderBottom: '1px solid #787878',
    },
  },
  branch: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',

    minHeight: '40px',
    padding: '8px 0px 0px 8px',

    backgroundColor: '#FFF', //'#EEE',

    button: {
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      padding: '8px 8px 8px 12px',
      minWidth: '120px',
      color: '#787878',
      marginBottom: '2px',
      fontSize: '14px',
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    parent: {
      backgroundColor: '#EEE',
      borderRadius: '4px',
      padding: '2px 4px',
    },
    collapse: {
      marginTop: '-1px',
      marginLeft: '24px',
      '& > * > *': {
        borderBottom: '1px solid #787878',
        borderTop: '1px solid #787878',
        marginBottom: '-1px',
      },
      '& > * > * > * > *:not(:last-child)': {
        borderBottom: '1px solid #787878',
        marginBottom: '-1px',
      },
    },
  },
}
